export default __webpack_public_path__ + "static/media/tazein.83227f40.png";